import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Apps } from './components/Apps';
import { Footer } from './components/Footer';
import { Support } from './components/Support';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { EmbeddedApps } from './components/EmbeddedApps';
import { BlogIndex } from './components/blog/BlogIndex';
import { BlogPost } from './components/blog/BlogPost';
import { RoamShopping } from './components/RoamShopping';
import { RoamWeather } from './components/RoamWeather';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function Landing() {
  useEffect(() => {
    document.title = 'Roam - Outdoor Adventure Apps';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Roam - Essential apps for outdoor enthusiasts. Weather forecasts, navigation tools, and adventure planning for hikers, climbers, and outdoor adventurers.'
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      <Hero />
      <Apps />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/embedded-apps" element={<EmbeddedApps />} />
        <Route path="/shopping" element={<RoamShopping />} />
        <Route path="/weather" element={<RoamWeather />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
